import Autolink from 'components/Autolink'
import { ThreadQueryResult } from 'graphql/generated'
import { humanTime, formatTimeLabel } from 'lib/datetime'
import CollectiveUserPopover from '../Common/CollectiveUserPopover'
import moment from 'moment'
import { useState, useEffect } from 'react'
import Link from 'next/link'
import ProposalStatusBadge from '../CollectiveProposals/ProposalStatusBadge'

const ThreadProposal: React.FC<{
  thread: NonNullable<ThreadQueryResult['thread']>
  proposal: NonNullable<ThreadQueryResult['thread']['proposal']>
}> = ({ thread, proposal }) => {
  const [secondsLeft, setSecondsLeft] = useState(
    (moment(proposal.endTime).toDate().getTime() -
      moment().toDate().getTime()) /
      1000
  )

  useEffect(() => {
    if (secondsLeft <= 0) {
      return
    }

    const timer = setInterval(() => {
      setSecondsLeft(x => x - 1)
    }, 1000)

    return () => {
      clearInterval(timer)
    }
  }, [secondsLeft])

  return (
    <table className="table-auto w-full text-gray-900 font-medium text-left text-sm">
      <tbody className="rounded-md">
        <tr className="border border-gray-200 ">
          <th className="px-6 py-4 border-r border-gray-200">
            Proposal Title:{' '}
          </th>
          <td className="px-6 py-4 border-r border-gray-200">
            {proposal.title}
          </td>
        </tr>
        <tr className="border border-gray-200">
          <th className="px-6 py-4 border-r border-gray-200">Author:</th>
          <td className="px-6 py-4">
            <CollectiveUserPopover user={proposal.proposedBy.user} />
          </td>{' '}
        </tr>
        <tr className="border border-gray-200">
          <th className="px-6 py-4 border-r border-gray-200">Summary:</th>
          <td className="px-6 py-4">
            <div className="prose break-all">
              <Autolink as="div" newWindow>
                {thread.body}
              </Autolink>
            </div>
          </td>
        </tr>
        <tr className="border border-gray-200">
          <th className="px-6 py-4 border-r border-gray-200">Duration: </th>
          <td className="px-6 py-4 space-x-2">
            <span>{`Created ${humanTime(proposal.createdAt, true)}`}</span>
            {secondsLeft > 0 ? (
              <span>{` \u00b7 ${formatTimeLabel(
                secondsLeft,
                true
              )} left`}</span>
            ) : (
              <ProposalStatusBadge proposal={proposal} />
            )}
          </td>
        </tr>
        <tr className="border border-gray-200 rounded-b-md">
          <th className="px-6 py-4 border-r border-gray-200">Proposal Link:</th>
          <td className="px-6 py-4">
            <Link
              href={proposal.publicUrl}
              className="text-blue hover:underline"
            >
              See Proposal
            </Link>
          </td>
        </tr>
      </tbody>
    </table>
  )
}

export default ThreadProposal
